module.exports = __webpack_public_path__ + "img/iso.5031cf03.png";